<template>
  <footer class="footer text-center">
    © {{ (new Date()).getFullYear() }} TruVito &nbsp;&nbsp; <i class="fas fa-globe text-light-green" />
  </footer>
</template>

<script>
export default {
  name: 'WorkspaceFooter',
  data () {
    return {
      version: ''
    }
  },
  mounted () {
    // this.release();
  },
  methods: {
    release () {
      this.$api.get('/')
        .then(reply => {
          this.version = reply.data.version
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style scoped>
</style>
